<template xmlns:i-col="http://www.w3.org/1999/html">
  <Modal title="添加订单" v-model="editModal" width="700">
    <Form ref="form" class="form" :label-width="100" label-position="left"
          :model="formData" :rules="formRule">
      <Row>
        <i-col :span="11" :offset="1">
          <Form-item label="订单类型" prop="channel">
            <Select v-model.number="formData.channel" @on-change="loadCoursePackageTypeData2" filterable clearable transfer>
              <Option  v-for="item in $constant.orderChannelNew"
                       :value="item.code" :key="item.code">{{ item.text }}</Option>
            </Select>
          </Form-item>
        </i-col>
        <i-col :span="11" >
          <Form-item label="学生ID" prop="uid">
            <Input v-model.number="formData.uid" placeholder="必填" @on-blur="inputMobile"/>
          </Form-item>
        </i-col>
      </Row>
      <Row v-if="formData.channel === 1">
        <i-col :span="12" :offset="1">
          <Form-item label="介绍人" prop="inviteId" required>
            <Input v-model.number="formData.inviteId" placeholder="介绍人学生ID"/>
          </Form-item>
          <Form-item label="转介绍课时" prop="inviteClassHour" required>
            <Input v-model.number="formData.inviteClassHour" placeholder="上满一个月后系统系统会自动赠送"/>
          </Form-item>
        </i-col>
        <i-col :span="11">
          <Form-item label="转介绍凭证" prop="url">
            <multiple-image-upload :num="200" :defaultFileList="defaultPicList" v-model="formData.url" on-file-change="onFileChange"/>
          </Form-item>
        </i-col>
      </Row>
      <Row>
        <i-col :span="11" :offset="1">
          <Form-item label="学生姓名" prop="contractName">
            <Input v-model="formData.contractName" placeholder="选填"/>
          </Form-item>
        </i-col>
        <i-col :span="11" >
          <Form-item label="课程类型：" prop="tchChannel" >
            <Select v-model="formData.tchChannel" @on-change="loadCoursePackageTypeData" transfer>
              <Option v-for="item in $constant.tchChannel"
                      :value="item.code" :key="item.code">{{ item.text }}</Option>
            </Select>
          </Form-item>
        </i-col>

        <i-col :span="23" :offset="1">
          <Form-item label="课时数量明细" prop="courseType">
            <Select v-model="formData.courseType" :key="packageSelectKey" @on-change="onCourseTypeChange" filterable clearable transfer>
              <Option  v-for="item in courseScheduleListData"
                       :value="item.id" :key="item.id">{{ item.label }}</Option>
            </Select>
          </Form-item>
        </i-col>
<!--        <i-col :span="11" :offset="1">-->
<!--          <Form-item label="课时优惠类型" prop="discountType">-->
<!--            <Select v-model="formData.discountType" @on-change="onDiscountTypeChange" transfer>-->
<!--              <Option  v-for="item in discountTypeList"-->
<!--                       :value="item.value" :key="item.value">{{ item.label }}</Option>-->
<!--            </Select>-->
<!--          </Form-item>-->
<!--        </i-col>-->
        <i-col :span="11" :offset="1" >
          <Form-item label="赠送课时" prop="discountNum">
            <Input v-model.number="formData.discountNum" placeholder="赠送课时数" v-on:input="calculateLeaveNum"></Input>
          </Form-item>
        </i-col>
        <i-col :span="11" :offset="1" >
          <Form-item label="优惠金额" prop="discount">
            <Input v-model.number="formData.discount" placeholder="优惠金额" v-on:input="calculatePayAmount"></Input>
          </Form-item>
        </i-col>
        <i-col :span="23" :offset="1" style="display: none">
          <Form-item label="优惠说明" prop="discountRemark">
            <Input v-model.number="formData.discountRemark" placeholder="有优惠时必填"></Input>
          </Form-item>
        </i-col>
        <i-col :span="11" :offset="1">
          <Form-item label="订单原价" prop="amount">
            <Input v-model.number="formData.amount" placeholder="必填" v-on:input="calculatePayAmount"></Input>
          </Form-item>
        </i-col>
        <i-col :span="11" :offset="1">
          <Form-item label="优惠价" prop="amount">
            <Input v-model.number="formData.payAmount" placeholder="必填"></Input>
          </Form-item>
        </i-col>

<!--        <i-col :span="11" :offset="1">-->
<!--          <Form-item label="收款公司" prop="payCompany">-->
<!--            <Select v-model="formData.payCompany" transfer>-->
<!--              <Option :value="10">邦德尔(销售)</Option>-->
<!--              <Option :value="11">虹兴达(学导)</Option>-->
<!--            </Select>-->
<!--          </Form-item>-->
<!--        </i-col>-->
        <i-col :span="11" :offset="1">
          <Form-item label="是否分笔：">
            <Checkbox v-model="formData.hasTwoPay" >分笔付款</Checkbox>
          </Form-item>
        </i-col>
        <i-col :span="5" :offset="1" v-if="formData.hasTwoPay === true">
          <InputNumber :max="3" :min="2" v-model.number="formData.twoPayNum" @on-change="zero"></InputNumber>
        </i-col>
        <i-col :span="5" v-if="formData.hasTwoPay === true">
          <Form-item label="首笔款:" prop="firstPay" :label-width="55" >
            <Input v-model.number="formData.firstPay" placeholder="不得少于1000" @on-change="calculate"></Input>
          </Form-item>
        </i-col>
        <i-col :span="5" :offset="1" v-if="formData.twoPayNum === 3">
          <Form-item label="二笔款:" prop="secondPay" :label-width="55" >
            <Input v-model.number="formData.secondPay" placeholder="不得少于1000" @on-change="calculate"></Input>
          </Form-item>
        </i-col>
        <i-col :span="5" :offset="1" v-if="formData.hasTwoPay === true">
          <Form-item label="尾款:" prop="" :label-width="55">
            <Input v-model.number="formData.lastPay" disabled></Input>
          </Form-item>
        </i-col>

        <i-col :span="11" :offset="1" v-if="formData.tchChannel === 2">
          <Form-item label="报名加赠课时" prop="giveNum">
            <Input v-model.number="formData.giveNum" placeholder="必填" disabled></Input>
          </Form-item>
        </i-col>
        <i-col :span="11" :offset="1" v-if="formData.tchChannel === 1" style="display: none">
          <Form-item label="请假次数" prop="leaveNum">
            <Input v-model.number="formData.leaveNum" placeholder="必填" disabled/>
          </Form-item>
        </i-col>
        <i-col :span="11" :offset="1" v-if="formData.tchChannel === 2">
          <Form-item label="抵消课机会" prop="leaveNum">
            <Input v-model.number="formData.leaveNum" placeholder="必填" disabled/>
          </Form-item>
        </i-col>
        <i-col :span="20" :offset="1" v-if="formData.tchChannel === 1" style="display: none">
          <Form-item label="补课次数">
            <Input v-model.number="formData.makeupLessonNum" placeholder="必填"  disabled style="width: 207px"/>
          </Form-item>
        </i-col>
        <i-col :span="20" :offset="1" v-if="formData.tchChannel === 2">
          <Form-item label="24小时内取消课机会">
            <Input v-model.number="formData.makeupLessonNum" placeholder="必填"  disabled style="width: 207px"/>
          </Form-item>
        </i-col>
<!--        <i-col :span="11" :offset="1">-->
<!--          <Form-item label="代理订单" prop="agentOrder">-->
<!--            <Select v-model="formData.agentOrder" transfer>-->
<!--              <Option value="0">否</Option>-->
<!--              <Option value="1">是</Option>-->
<!--            </Select>-->
<!--          </Form-item>-->
<!--        </i-col>-->
<!--        <i-col :span="16" :offset="1" style="display: none">-->
<!--          <Form-item label="配送礼品" prop="bookMaterialLevel">-->
<!--            <Select v-model="formData.bookMaterialLevel" placement="top" filterable clearable multiple transfer>-->
<!--                <Option v-for="item in materialPrice" :value="item.id" :key="item.id">{{item.title}}</Option>-->
<!--            </Select>-->
<!--          </Form-item>-->
<!--        </i-col>-->
        <i-col :span="22" :offset="1">
          <Form-item label="编辑合同" prop="contractVersionId">
            <Select v-model="formData.contractVersionId" @on-change="onChangeSelectContractVersion"  placement="top" filterable>
              <Option v-for="item in versionList" :value="item.id" :key="item.id">{{ item.title}}</Option>
            </Select>
          </Form-item>
        </i-col>

        <i-col :span="11" :offset="1" v-if="showDealMonth">
          <Form-item label="成交月份" prop="dealMonth">
            <Select v-model="formData.dealMonth" placeholder="请选择成交月份" transfer>
              <Option v-for="item in dealMonthOptions"
                      :value="item.value" :key="item.value">{{ item.label }}</Option>
            </Select>
          </Form-item>
        </i-col>
      </Row>
    </Form>
    <div slot="footer">
      <Button type="text" size="large" @click="onClose">取消</Button>
      <Button type="primary" size="large" :loading="loading" @click="onInsert">保存</Button>
    </div>
  </Modal>
</template>
<script>
  export default {
    name: 'AddOrderModal',
    props: {
      value: {
        type: Boolean,
        default: false
      },
      successCallback: {
        type: Function
      }
    },
    data () {
      return {
        loading: false,
        isAdviser: false,
        courseScheduleListData: null,
        allCoursePackageList: [],
        isAgent: null,
        packageSelectKey: 0,
        discountTypeList: [
          {
            value: 1,
            label: '课时赠送'
          },
          {
            value: 2,
            label: '现金减免'
          },
//          {
//            value: 4,
//            label: '课时赠送及现金减免'
//          },
          {
            value: 3,
            label: '不参与活动'
          }
        ],
        materialPrice: [],
        versionList: [],
        showDealMonth: false,
        dealMonthOptions: [
          {
            value: 1,
            label: '上月'
          },
          {
            value: 0,
            label: '本月'
          }
        ],
        formData: {
          uid: null,
          mobile: null,
          amount: null,
          preferentialAmount: null,
          payAmount: null,
          courseType: null,
          discountType: null,
          discountNum: 0,
          discount: 0,
          discountRemark: null,
          bookMaterialLevel: [],
          leaveNum: 0,
          makeupLessonNum: 0,
          effectDays: null,
          minorNum: 0,
          address: null,
          contractVersionId: null,
          contractName: null,
          tchChannel: null,
          desc: '',
          needInvoice: '0',
          needContract: '0',
          invoiceDetail: '',
          hasTwoPay: false,
          twoPayNum: 2,
          firstPay: 0,
          secondPay: 0,
          lastPay: 0,
          limitCancelLessonNum: 0,
          limitOffsetLessonNum: 0,
          giveNum: 0,
          agentOrder: '0',
          channel: null,
          url: '',
          inviteId: null,
          inviteClassHour: '',
          dealMonth: null,
          payCompany: 11
        },
        formRule: {},
        defaultPicList: []
      }
    },
    computed: {
      editModal: {
        get: function () {
          return this.value
        },
        set: function (newValue) {
          this.onClose()
        }
      }
    },
    methods: {
      inputMobile () {
        let self = this
        let uid = self.formData.uid
        if (uid) {
          // 查询手机号 + 是否代理渠道
          self.$http.get('/agentInvite/queryByUid', {params: {'uid': uid}}).then(function (res) {
            if (!res || !res.data) {
              return
            }
            self.formData.inviteId = res.data.inviteId
            self.formData.contractName = res.data.userNickname
            if (typeof res.data.isAgent === 'boolean') {
              self.isAgent = res.data.isAgent
            } else {
              self.isAgent = null
            }
            self.applyPackageFilters()
          })
        } else {
          self.isAgent = null
          self.applyPackageFilters()
        }
      },
      onInsert () {
        let self = this
        // 动态设置验证规则
        self.formRule = {
          uid: [
            {type: 'integer', required: true, message: '学生 ID 不能为空', trigger: 'blur'}
          ],
          amount: [
            {type: 'number', required: true, message: '不能为空', trigger: 'blur'}
          ],
          payAmount: [
            {type: 'number', required: true, message: '不能为空', trigger: 'blur'}
          ],
          courseType: [
            {type: 'number', required: true, message: '不能为空', trigger: 'blur'}
          ],
          discount: [
            {type: 'number', required: true, message: '不能为空', trigger: 'blur'}
          ],
          discountNum: [
            {type: 'integer', required: true, message: '不能为空', trigger: 'blur'}
          ],
          contractVersionId: [
            {type: 'integer', required: true, message: '合同不能为空', trigger: 'blur'}
          ],
          contractName: [
            {type: 'string', required: true, message: '不能为空', trigger: 'blur'}
          ],
          tchChannel: [
            {type: 'integer', required: true, message: '不能为空', trigger: 'blur'}
          ],
          channel: [
            {type: 'number', required: true, message: '不能为空', trigger: 'blur'}
          ]
        }

        self.loading = true
        self.$refs.form.validate((valid) => {
          if (!valid) {
            self.$Message.warning('信息输入错误!')
            self.loading = false
            return
          }
          if (self.formData.channel === 1 && self.formData.url === '') {
            self.$Message.warning('请上传转介绍凭证!')
            self.loading = false
            return
          }
          if (self.formData.channel === 1 && self.formData.inviteId === '') {
            self.$Message.warning('请填介绍人 ID!')
            self.loading = false
            return
          } if (self.formData.channel === 1 && (self.formData.inviteClassHour === '' || self.formData.inviteClassHour < 0)) {
            self.$Message.warning('请填写转介绍课时')
            self.loading = false
            return
          }
          self.$http.post('/fundPackage/insert', self.formData).then(res => {
            if (res && res.data > 0) {
              self.$Message.success('提交成功!')
              self.successCallback()
              self.onClose()
              self.onSuccess()
            }
            if (res && res.status === '505') {
              self.formData.dealMonth = 1
              self.showDealMonth = true
              // 添加 dealMonth 的必填验证规则
              self.formRule = {
                ...self.formRule,
                dealMonth: [
                  {type: 'number', required: true, message: '成交月份不能为空', trigger: 'blur'}
                ]
              }
              self.$Message.warning('请选择成交月份')
            }
            self.loading = false
          })
        })
      },
      loadCoursePackageTypeData (val) {
        let self = this
        self.$http.get('/common/coursePackageTypeList?tchChannel=' + val).then(function (res) {
          if (!res || !res.data) {
            return
          }

          res.data.forEach(item => {
            item.label = item.title + '：' + item.routineNum + '节外教课'
          })

          self.allCoursePackageList = res.data
          self.applyPackageFilters()
        })
      },

      loadCoursePackageTypeData2 (channel) {
        this.applyPackageFilters()
      },
      applyPackageFilters () {
        let list = (this.allCoursePackageList || []).slice()
        if (this.formData.channel === 11) {
          list = list.filter(function (item) {
            return item.routineNum === 1
          })
        }
        if (this.isAgent === true) {
          list = list.filter(function (item) {
            return (item.title || '').indexOf('D') >= 0
          })
        } else if (this.isAgent === false) {
          list = list.filter(function (item) {
            return (item.title || '').indexOf('D') < 0
          })
        }
        this.courseScheduleListData = list
        if (this.formData.courseType && !list.some(function (item) {
          return item.id === this.formData.courseType
        }.bind(this))) {
          this.clearSelectedCourseType()
          this.$Message.warning('当前学生渠道与已选套餐不符，请重新选择')
        }
      },
      clearSelectedCourseType () {
        this.formData.courseType = null
        this.packageSelectKey += 1
        this.formData.amount = null
        this.formData.num = null
        this.formData.livingNum = null
        this.formData.chineseNum = null
        this.formData.partnerNum = null
        this.formData.preferentialAmount = null
        this.formData.giveNum = null
        this.formData.leaveNum = null
        this.formData.makeupLessonNum = null
        this.formData.desc = ''
        this.formData.effectDays = null
        this.formData.payAmount = null
      },
      onCourseTypeChange (val) {
        let self = this
        if (val) {
          self.courseScheduleListData.forEach(item => {
            if (val === item.id) {
              self.formData.amount = item.amount
              self.formData.num = item.routineNum
              self.formData.livingNum = item.livingNum
              self.formData.chineseNum = item.chineseNum
              self.formData.partnerNum = item.partnerNum
              self.formData.preferentialAmount = item.preferentialAmount
              self.formData.giveNum = item.giveNum
              self.formData.leaveNum = item.limitCancelLessonNum
              self.formData.makeupLessonNum = item.limitOffsetLessonNum
              self.formData.desc = item.title
              self.formData.effectDays = item.effectDays
              self.calculatePayAmount()
              self.calculateLeaveNum()
            }
          })
        } else {
          self.formData.amount = null
        }
      },
      calculatePayAmount () {
        this.zero()
        if (this.formData.amount) {
          if (this.formData.discount) {
            this.formData.payAmount = (this.formData.amount - this.formData.discount).toFixed(2)
          } else {
            this.formData.payAmount = this.formData.amount
          }
        }
        if (this.formData.tchChannel === 2) {
          if (this.formData.discount) {
            this.formData.payAmount = (this.formData.preferentialAmount - this.formData.discount).toFixed(2)
          } else {
            this.formData.payAmount = this.formData.preferentialAmount
          }
        }
      },
      calculateLeaveNum () {
        if (this.formData.tchChannel === 2) {
          return
        }
        if (this.formData.num) {
          if (this.formData.discountNum) {
            this.formData.leaveNum = Math.floor((this.formData.num + this.formData.discountNum) / 40)
            this.formData.makeupLessonNum = Math.floor((this.formData.num + this.formData.discountNum) / 10)
          } else {
            this.formData.leaveNum = Math.floor(this.formData.num / 40)
            this.formData.makeupLessonNum = Math.floor(this.formData.num / 10)
          }
        }
      },
      onClose () {
        this.$emit('on-close')
      },
      onSuccess () {
        this.$emit('on-success')
      },
      zero () {
        this.formData.firstPay = 0
        this.formData.secondPay = 0
        this.formData.lastPay = 0
      },
      calculate () {
        if (this.formData.twoPayNum === 2) {
          this.formData.lastPay = (this.formData.payAmount - this.formData.firstPay).toFixed(2)
        } else if (this.formData.twoPayNum === 3) {
          this.formData.lastPay = (this.formData.payAmount - (this.formData.firstPay + this.formData.secondPay)).toFixed(2)
        }
      },
      queryContract () {
        let self = this
        self.$http.post('/common/contractSelect?type=1', {
          pageSize: 1000,
          pageIndex: 1,
        }).then(function (res) {
          if (res && res.data) {
            self.versionList = res.data.data
          }
        })
      },
      onChangeSelectContractVersion (val) {
        this.formData.contractVersionId = val
      },
      resetDealMonthField () {
        this.showDealMonth = false
        this.formData.dealMonth = null
        // 清空验证规则
        this.formRule = {}
      },
      setDefaultPayCompany () {
        // 根据 adviserInfo 设置默认收款公司
        if (this.isAdviser) {
          this.formData.payCompany = '11'
        } else {
          this.formData.channel = 3
          this.formData.payCompany = '11'
        }
      }
    },
    created () {
      // 页面加载时判断当前用户是否为销售顾问
      this.isAdviser = !!this.$store.get('adviserInfo')
    },
    watch: {
      value (val) {
        let self = this
        if (val === true) {
          self.isAgent = null
          self.formData.hasTwoPay = false
          self.formData.twoPayNum = 2
          self.formData.firstPay = 0
          self.formData.secondPay = 0
          self.formData.lastPay = 0
          self.formData.dealMonth = null
          self.resetDealMonthField()
          self.setDefaultPayCompany()
          self.loadCoursePackageTypeData(1)
          self.queryContract()
          self.$http.get('/materialPrice/list').then(function (res) {
            if (res.data) {
              self.materialPrice = res.data
            }
          })
        } else if (val === false) {
          this.formData.needInvoice = '0'
          this.formData.needContract = '0'
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// AddOrderModal.vue?65e12612